import React, { useEffect } from 'react'
import { isMobile, isTablet, isMobileOnly } from "react-device-detect"
import { css } from 'emotion'
import { Container } from 'reactstrap';
import RtceSlides from './RtceSlides';
import EirButton from '../eir-button/EirButton';
import { LargeBusiness, moduleMargins, htmlWidget } from '../../Constants';

const RtceDisplay = (props) => {

    const renderContent = (content) => {
        return { __html: content };
    }
    const isLBSite = (LargeBusiness.isLBSite);
    //useEffect(()=>{       
    //}, [])
    
    let [marginDesktop, marginMobile] = moduleMargins(props.rtce.MarginDT, props.rtce.MarginMobile);
    const rcteProps = {
        marginClass : (!isMobile) ? marginDesktop : marginMobile,
        containerClass: (isLBSite) ? 'rtce-main rtce-business-lb' : 'rtce-main',
        htmlWidget: htmlWidget
    }
    // console.log(props.rtce.MarginDT, props.rtce.MarginMobile, rcteProps)
    return (
        <div className={`${rcteProps.containerClass} ${rcteProps.marginClass}`} id={"rtce-ctr-" + props.rtce.occurence}>
            <div className={css`background-color: ${(isMobile && !isTablet) ? props.rtce.backgroundColorMobile : props.rtce.backgroundColor};`} > {/* added spacing module*/}
                <div className={'homepage-modules-title container' + rcteProps.htmlWidget} dangerouslySetInnerHTML={renderContent(props.rtce.title)}></div>
                <Container className={isMobileOnly ? 'mobilelandscapeContainer ' : '' + (!isMobile ? 'not-mobile-RTCE' : 'mobile-RTCE')}>
                    <RtceSlides slides={props.rtce} />
                    {
                        props.rtce.cta &&
                        <div className={(isMobile && !isTablet ? 'mobile-bottom-cta ' : '') + 'd-flex justify-content-center rtce-bottom-cta align-items-center mb-3 mt-3'}>
                            {/* <EirButton databundlecode={"rtce_bottom_cta"} className={(props.rtce.cta.type !== 'link' ? (css`border-color: ${props.rtce.outlineColorBottomCta}; &:hover, &:focus, &:focus-within, &:active {background: ${props.rtce.outlineColorBottomCta} !important;border-color: ${props.rtce.outlineColorBottomCta} !important}`) : 'link-cta') + ' js-prequal-modal-btn eir-text-secondary ls-0 p-2 cta_threesix'} {...props.rtce.cta} /> */}
                            <EirButton  ariaLabel={props.rtce.cta.ariaLabel} databundlecode={"rtce_bottom_cta"} useInlineCSS={(props.rtce.cta.buttonStyle === '' && props.rtce.BottomCTABackgroundColor !=='' )?true:false} className={(props.rtce.cta.type !== 'link' ? (css`background: ${props.rtce.BottomCTABackgroundColor}; border-color: ${props.rtce.BottomCTAOutlineColor}; color:${props.rtce.BottomCTAFontColor}; &:hover, &:focus, &:focus-within, &:active {background: ${props.rtce.BottomCTABackgroundHoverColor} !important;border-color: ${props.rtce.BottomCTAOutlineHoverColor} !important; color:${props.rtce.BottomCTAFontHoverColor}}`) : 'link-cta') + ' js-prequal-modal-btn eir-text-secondary ls-0 p-2 reasonToChooseCTA cta_threesix'} 
                            {...props.rtce.cta} />
                        </div>
                    }
                </Container>
            </div>
        </div>
    )
}

// css`border-color: ${tile.OutlineColorCTA}; &:hover, &:focus {background: ${tile.OutlineColorCTA};border-color: ${tile.OutlineColorCTA}}` + 

export default RtceDisplay
